import permissions from '../../data/permissions';

export default [
    {
        name: "SupplierContactCreate",
        path: "supplier-contact",
        component: () => import('../../views/purchase/SupplierContactCreateView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_contact.create }
    },
    {
        name: "SupplierContactDisplay",
        path: "supplier-contact/:id",
        component: () => import('../../views/purchase/SupplierContactDisplayView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_contact.read }
    },
    {
        name: "SupplierContactEdit",
        path: "supplier-contact/:id/edit",
        component: () => import('../../views/purchase/SupplierContactEditView.vue'),
        meta: { requiresAuth: true, authorization: permissions.supplier_contact.update }
    }
 
]